import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {SessionNames} from "../../../shared/session/session-names";
import {PageDescription} from "../../../shared/pages/page-description";
import {CCRolesType} from "../../../model/security/cc-roles-type";
import {Router} from "@angular/router";
import {CrystalClearFrontUrlCustomer} from "../../../shared/pages/crystal-clear-front-url-customer";
import {AppConfigService} from "../../../services/app-config.service";

@Component({
  selector: 'app-customer-sidebar',
  templateUrl: './customer-sidebar.component.html',
  styleUrls: ['./customer-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class CustomerSidebarComponent implements OnInit {

  sidebarToggledChange: boolean = true;

  transPartKey: string = 'page.customer';

  menuItemsTop: MenuItem[] = [];
  menuItemsBottom: MenuItem[] = [];

  constructor(public router: Router,
              private appConfigService: AppConfigService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    //load from cookies
    // if (this.cookieService.check(CookieNames.MENU_SIDE_BAR_MAXIMIZED)) {
    //   if (this.cookieService.get(CookieNames.MENU_SIDE_BAR_MAXIMIZED) === 'true') {
    //     this.sidebarToggledChange = true;
    //   }
    // }
    const roles = JSON.parse(sessionStorage.getItem(SessionNames.USER_ROLES));
    if (roles) {
      this.menuItemsTop = [
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_OWNER, roles, false),
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_CUSTOMER, roles, false),
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_ACCOUNT, roles, false),
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_ACCEPTANCE_RULE, roles, false),
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_CUSTOMER_LIMITS, roles, false),
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_BROKER, roles, false),
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_BANK_ACCOUNT, roles, false),
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_ACCOUNT_TRADER, roles, false),
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_TRADER, roles, false),
      ];
      if (this.appConfigService.billingEnabled) {
        this.menuItemsTop.push(
          this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_EXEC_TRADER, roles, false),);
      }
      this.menuItemsTop.push(
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_VAT_RATE, roles, false),
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_MONEY_OWNER, roles, false),
        this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_BROKERAGE_TABLE, roles, false));
    }
  }

  SizeChanged($event) {
    // this.cookieService.set(CookieNames.MENU_SIDE_BAR_MAXIMIZED, $event);
  }

  private toMenuItem(pDesc: PageDescription, roles: CCRolesType.Roles[], iconOnly: boolean, subItems: MenuItem[] = []): MenuItem {
    return PageDescription.toMenuItem(pDesc, this.translateService,
      this.router, roles, iconOnly, subItems);
  }
}
